import { createContext } from 'react';
import { ActivityLogDataCtx } from './types';
import { activitiesLogInitialValues } from './utils';
import { FCProps } from 'types/FCProps';
import useActivityLogData from 'hooks/useActivityLogData';

export const ActivityLogContext = createContext<ActivityLogDataCtx>(activitiesLogInitialValues);

const ActivityLogProvider = ({ children }: FCProps): JSX.Element => {
  const {
    fetching,
    activitiesLogTable,
    isEmpty,
    filters,
    activityLogUsers,
    isPollingCircuitOpen,
    onChangeFilter,
    onChangeFilters,
    onChangeRangeFilters,
    onRetryPolling,
    onRetrieveActivityLogUsers,
    onResetActivities,
  } = useActivityLogData();

  return (
    <ActivityLogContext.Provider
      value={{
        fetching,
        isEmpty,
        table: activitiesLogTable,
        filters,
        activityLogUsers,
        isPollingCircuitOpen,
        actions: {
          onChangeFilter,
          onChangeFilters,
          onChangeRangeFilters,
          onRetryPolling,
          onRetrieveActivityLogUsers,
          onResetActivities,
        },
      }}
    >
      {children}
    </ActivityLogContext.Provider>
  );
};

export default ActivityLogProvider;
